module.exports = __webpack_public_path__ + "img/calendar.36c3cdaf.svg";